import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { commissionEditAction, commissionSearchAction } from '../commission-container/actions/CommissionActions';
import CommissionForm from '../commission-container/CommissionForm';
import WalletForm from './WalletForm';
import TargetForm from '../target-container/TargetForm';
import { walletEditAction, walletSearchAction } from './actions/WalletActions';
import { walletPaymentSearchAPI } from 'src/api/WalletApi';



const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.walletManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.walletSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.walletManagerUrl(),
        component: () => (
            <PermissionHOC
                scope="wallet.wallet_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<WalletForm />}
            />
        ),
    },
    {
        link: RoutingUtil.walletSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="wallet.wallet_manager.search"
                editScope="wallet.wallet_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="WalletReducer"
                dataPath="search"
                editAction={walletEditAction}
                redirectUrlOnEdit={RoutingUtil.walletManagerUrl()}
                action={walletSearchAction}
                columns={{
                    agentId: {
                        display: 'Agent/User Name',
                        path:"agentId.personalInfo.firstName"
                    },
                    paymentType: {
                        display: 'Type of Payment',
                         path: "payment_type"
                    },
                    category:{
                        display: 'Category',
                        path: "category" 
                    },
                    caseCode:{
                        display: 'Case Code',
                        path: "caseCode" 
                    },
                    instrument_number:{
                        display: 'Instrument Number',
                         path: "instrument_number"
                    },
                    amount: {
                        display: 'Amount',
                        path: "amount"
                    },
                    date: {
                        display: 'Pay Date',
                        path: "payment_date",
                        type: Date
                    },
                    remarks: {
                        display: 'Remarks',
                         path: "remarks"
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const WalletContainer = () =>{
    return(
    <CrudLayoutContainer
        title="Wallet Manager"
        tabs={tabs}
        routes={routes}
    />
)};

WalletContainer.propTypes = {
};

export default WalletContainer;
